import api from "../../../Services/api";
import React, { useEffect, useState, useCallback, useMemo } from "react";
import MenuLateral from "../../../Componentes/MenuLateral";
import MenuSuperior from "../../../Componentes/MenuSuperior";
import { useAuthContext } from "../../../context/authContext";
import { useOperador } from "../../../Hooks/useOperador";
import { useNavigate, useParams } from "react-router-dom";
import debounce from "lodash.debounce";
import {
  FiSearch,
  FiX,
  FiChevronLeft,
  FiChevronRight,
  FiArrowUp,
  FiArrowDown,
  FiCheck,
  FiMove,
} from "react-icons/fi";
import { FaCheckCircle, FaTimesCircle, FaArchive, FaFileAlt } from "react-icons/fa";
import { TfiClip } from "react-icons/tfi";
import { MdPlaylistAdd, MdPlaylistRemove } from "react-icons/md";
import { LuFileX2, LuGitCompareArrows } from "react-icons/lu";
import { IoReturnDownBackOutline } from "react-icons/io5";
import * as Enum from "../../../Enum/Enum";
import * as chkAuditoriaUtils from "../../../Services/Auditoria/chkAuditoriaUtils";
import requestPreSignedUrlAws from "../../../Services/requestPreSignedUrlAws";
import CadastroQuestaoModal from "./cadastroQuestaoModal";
import AssociacaoQuestaoModal from "./associacaoQuestaoModal";
import ModalSelecionarObjeto from "./ModalSelecionarObjeto";
import Swal from "sweetalert2";
import "./index.css";

const AuditoriaQuestao = () => {

  const { IDSecao, modelo: somenteQuestaoModelo } = useParams();

  const [questoes, setQuestoes] = useState([]);
  const [secao, setSecao] = useState(null);
  const [total, setTotal] = useState(0);
  const [objetosPorId, setObjetosPorId] = useState({});

  const [showModalAssociarQuestao, setShowModalAssociarQuestao] = useState(false);

  const [showModalQuestao, setShowModalQuestao] = useState(false);
  const [questaoEditando, setQuestaoEditando] = useState(null); // null = nova questão
  const [showModalObjeto, setShowModalObjeto] = useState(false);
  const [questaoSelecionadaObjeto, setQuestaoSelecionadaObjeto] = useState(null);

  const [somenteModelo, setSomenteModelo] = useState(false);
  const [isReordenando, setIsReordenando] = useState(false);
  const [questoesOrdenadas, setQuestoesOrdenadas] = useState([]);
  const [salvandoOrdem, setSalvandoOrdem] = useState(false);
  const [removendoObjetoId, setRemovendoObjetoId] = useState(null);

  const [page, setPage] = useState(1);
  const limit = 20;

  // ❗filtro digitado e filtro aplicável são separados
  const [filter, setFilter] = useState("");
  const [debouncedFilter, setDebouncedFilter] = useState("");

  const [loading, setLoading] = useState(false);

  const { authReady } = useAuthContext();
  const { IDOperador, nome, operador, permissaoPrincipal } = useOperador();

  const navigate = useNavigate();
  let idFormatado = String(IDOperador).padStart(6, '0');
  const hasSecaoParam = Boolean(IDSecao);
  const secaoId = Number.isNaN(Number(IDSecao)) ? null : Number(IDSecao);
  const isSecaoFinalizada = secao?.situacao === 2;

  const modeloFilter = Number(somenteQuestaoModelo);
  const questoesFiltradas = somenteModelo
    ? questoes.filter(q => q.questaoModelo === 1)
    : questoes;
  const podeReordenar = Number(secaoId) > 0 && !debouncedFilter && !somenteModelo;

  const hasCargo = useMemo(() => {
    const cargos = operador?.cargos ?? [];
    return (nomeCargo) => cargos.some((c) => c.descricao === nomeCargo);
  }, [operador]);

  const isAdmin = useMemo(() => {
    return operador?.permissaoPrincipal === 99 || hasCargo("Administrador");
  }, [operador, hasCargo]);

  const ordenarPorOrdem = useCallback((lista) => {
    return [...lista].sort((a, b) => {
      const ordemA = a.ordem ?? 0;
      const ordemB = b.ordem ?? 0;
      if (ordemA !== ordemB) return ordemA - ordemB;
      return (a.IDQuestao_Secao ?? 0) - (b.IDQuestao_Secao ?? 0);
    });
  }, []);

  const questoesOrdenadasPorOrdem = useMemo(() => {
    if (!secaoId) return questoesFiltradas;
    return ordenarPorOrdem(questoesFiltradas);
  }, [secaoId, questoesFiltradas, ordenarPorOrdem]);


  const handleDebounce = useCallback(
    debounce((value) => {
      setDebouncedFilter(value);
      setPage(1); // Sempre volta pra primeira página quando filtra
    }, 500),
    []
  );

  // Quando o usuário digita → dispara debounce
  const onChangeFiltro = (e) => {
    const value = e.target.value;
    setFilter(value);
    handleDebounce(value);
  };

  const handleVoltar = () => {
    if (secao?.IDCliente) {
      navigate(`/AuditoriaSecao/${secao.IDCliente}`);
    }
  };

  useEffect(() => {
    if (authReady) {
      if (!operador) {
        navigate("/");
      }
    }
  }, [authReady, operador, secaoId]);

  useEffect(() => {
    if (secaoId) fetchSecao();
  }, [secaoId]);

  useEffect(() => {
    fetchQuestoes();
  }, [page, debouncedFilter, secaoId, modeloFilter]);

  useEffect(() => {
    setPage(1);
  }, [debouncedFilter]);

  useEffect(() => {
    if (isReordenando) {
      setQuestoesOrdenadas(questoesOrdenadasPorOrdem);
    }
  }, [isReordenando, questoesOrdenadasPorOrdem]);

  useEffect(() => {
    if (isReordenando && !podeReordenar) {
      setIsReordenando(false);
      setQuestoesOrdenadas([]);
    }
  }, [isReordenando, podeReordenar]);

  useEffect(() => {
    if (!questoes.length) return;
    const idsUnicos = [
      ...new Set(
        questoes.map((questao) => questao?.IDObjeto).filter(Boolean)
      ),
    ];
    const idsParaBuscar = idsUnicos.filter(
      (id) => objetosPorId[id] === undefined
    );
    if (!idsParaBuscar.length) return;

    let cancelado = false;

    const carregarObjetos = async () => {
      const resultados = await Promise.all(
        idsParaBuscar.map((id) => chkAuditoriaUtils.getObjetoQuestao(id))
      );
      if (cancelado) return;

      setObjetosPorId((prev) => {
        const next = { ...prev };
        idsParaBuscar.forEach((id, index) => {
          next[id] = resultados[index] || null;
        });
        return next;
      });
    };

    carregarObjetos();

    return () => {
      cancelado = true;
    };
  }, [questoes, objetosPorId]);


  useEffect(() => {
    return () => {
      handleDebounce.cancel();
    };
  }, [handleDebounce]);

  const clearFilter = () => {
    setFilter("");
    setDebouncedFilter("");
    setPage(1);
  };

  const abrirModalNovaQuestao = () => {
    if (isSecaoFinalizada) return;
    setQuestaoEditando(null);
    setShowModalQuestao(true);
  };

  const abrirModalAssociarQuestao = () => {
    if (isSecaoFinalizada) return;
    setShowModalAssociarQuestao(true);
  };

  const abrirModalEditarQuestao = (questao) => {
    if (isSecaoFinalizada) return;
    setQuestaoEditando(questao);
    setShowModalQuestao(true);
  };

  const abrirModalObjeto = (questao) => {
    if (isSecaoFinalizada) return;
    setQuestaoSelecionadaObjeto(questao);
    setShowModalObjeto(true);
  };

  const buscaTodasQuestoes = async ({ page = 1, limit = 20, filter = "" }) => {
    const response = await api.get(`/chkquestoesstats`, {
      params: { page, limit, filter },
    });
    setQuestoes(response.data.data);
    setTotal(response.data.total);

    return response.data;
  };

  const buscaPorSecao = async ({ page = 1, limit = 20, IDSecao: IDSecaoParam, filter = "" } = {}) => {
    const id = IDSecaoParam || secaoId;
    const response = await api.get(`/chkquestaosecao/secao`, {
      params: { page, limit, IDSecao: Number(id), filter },
    });
    setQuestoes(response.data.data);
    setTotal(response.data.total);

    return response.data.data;
  };

  const fetchSecao = async () => {
    try {
      setLoading(true);
      if (!secaoId) return;

      const response = await api.get(`/chksecao/${secaoId}`);
      setSecao(response.data);
    } finally {
      setLoading(false);
    }
  };

  const fetchQuestoes = async () => {
    try {
      setLoading(true);

      // 1️⃣ Buscar todas as questões
      // -----------------------------------
      if (!modeloFilter && !secaoId) {
        return await buscaTodasQuestoes({ page, limit, filter: debouncedFilter });
      }

      // 2️⃣ Filtrar apenas questões modelo
      // /AuditoriaQuestao/1
      // -----------------------------------
      if (modeloFilter === 1) {
        const todas = await buscaTodasQuestoes({ page, limit, filter: debouncedFilter });
        const apenasModelo = todas.filter(q => q.questaoModelo === 1);
        setQuestoes(apenasModelo);
        return;
      }

      // 3️⃣ Buscar questões por seção
      // /AuditoriaQuestao/0/:IDSecao
      // -----------------------------------
      if (modeloFilter === 0 && secaoId) {
        return await buscaPorSecao({ page, limit, IDSecao: secaoId, filter: debouncedFilter, });
      }
    } catch (error) {
      console.error("Erro ao carregar questões", error);
    } finally {
      setLoading(false);
    }
  }

  const getNomeArquivo = (path = "") => {
    if (!path) return "";
    const partes = String(path).split("/");
    return partes[partes.length - 1] || "";
  };

  const abrirArquivoInline = async (objeto) => {
    if (isSecaoFinalizada) return;
    if (!objeto) return;
    const bucket = objeto.nomeBucketAws || objeto.bucket || null;
    const caminho = objeto.caminho || null;
    const nome = objeto.descricao || getNomeArquivo(objeto.path);

    if (!bucket || !caminho) {
      alert("Não foi possível obter o link do arquivo.");
      return;
    }

    const urlArquivo = await requestPreSignedUrlAws(
      permissaoPrincipal,
      "getObject",
      bucket,
      caminho,
      nome,
      "inline"
    );

    if (!urlArquivo || typeof urlArquivo !== "string") {
      alert("Não foi possível obter o link do arquivo.");
      return;
    }

    window.open(urlArquivo, "_blank");
  };

  const vincularObjeto = async (selecionado) => {
    if (isSecaoFinalizada) return;
    if (!questaoSelecionadaObjeto || !selecionado) return;

    try {
      const confirm = await Swal.fire({
        title: "Confirmar vínculo?",
        html: `Deseja vincular <strong>${selecionado.label}</strong> à questão <strong>${questaoSelecionadaObjeto.titulo}</strong> na seção <strong>${secao?.descricao ?? "Seção"}</strong>?`,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Vincular",
        cancelButtonText: "Cancelar",
        cancelButtonColor: "var(--color-btnCancelar-danger)",
        customClass: {
          cancelButton: "swal-cancel-danger",
        },
      });
      if (!confirm.isConfirmed) return;

      const { tipo, IDReferencia } = selecionado;
      const responseResolve = await api.post("/chkobjeto/resolver", {
        tipo,
        IDReferencia,
        criarSeNaoExistir: true,
      });
      const idObjeto = responseResolve?.data?.IDObjeto ?? null;

      if (!idObjeto) {
        Swal.fire("Erro", "Não foi possível vincular o arquivo.", "error");
        return;
      }

      await api.put(`/chkquestaosecao/${questaoSelecionadaObjeto.IDQuestao_Secao}`, {
        IDQuestao: questaoSelecionadaObjeto.IDQuestao,
        IDSecao: secaoId,
        IDObjeto: idObjeto,
        ordem: questaoSelecionadaObjeto.ordem ?? 0,
      });

      setObjetosPorId((prev) => {
        if (!idObjeto || prev[idObjeto] === undefined) return prev;
        const next = { ...prev };
        delete next[idObjeto];
        return next;
      });

      setShowModalObjeto(false);
      setQuestaoSelecionadaObjeto(null);
      fetchQuestoes();
    } catch (error) {
      console.error("Erro ao vincular objeto", error);
      Swal.fire("Erro", "Não foi possível vincular o arquivo.", "error");
    }
  };

  const excluirObjetoDaQuestao = async (questao) => {
    if (isSecaoFinalizada) return;
    if (!questao?.IDQuestao_Secao || !questao?.IDObjeto) return;

    const confirm = await Swal.fire({
      title: "Excluir arquivo vinculado?",
      text: "O arquivo será desvinculado da questão. Deseja continuar?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Excluir",
      cancelButtonText: "Cancelar",
      cancelButtonColor: "var(--color-btnCancelar-danger)",
      customClass: {
        cancelButton: "swal-cancel-danger",
      },
      confirmButtonColor: "#d33",
    });

    if (!confirm.isConfirmed) return;

    try {
      setRemovendoObjetoId(questao.IDQuestao_Secao);

      const objeto = objetosPorId[questao.IDObjeto];
      let idObjeto = questao.IDObjeto;
      let totalVinculos = 0;

      if (objeto?.tipo && objeto?.IDReferencia) {
        const responseResolve = await api.post("/chkobjeto/resolver", {
          tipo: objeto.tipo,
          IDReferencia: objeto.IDReferencia,
          criarSeNaoExistir: false,
        });
        idObjeto = responseResolve?.data?.IDObjeto ?? idObjeto;
        totalVinculos = responseResolve?.data?.vinculos ?? 0;
      } else {
        const response = await api.get("/chkquestaosecao", {
          params: { page: 1, limit: 1, IDObjeto: questao.IDObjeto },
        });
        totalVinculos = response.data?.total ?? 0;
      }

      await api.put(`/chkquestaosecao/${questao.IDQuestao_Secao}`, {
        IDQuestao: questao.IDQuestao,
        IDSecao: secaoId,
        IDObjeto: null,
        ordem: questao.ordem ?? 0,
      });

      if (idObjeto && totalVinculos <= 1) {
        await api.delete(`/chkobjeto/${idObjeto}`);
      }

      setObjetosPorId((prev) => {
        const next = { ...prev };
        delete next[questao.IDObjeto];
        return next;
      });

      fetchQuestoes();

      Swal.fire("Sucesso", "Arquivo desvinculado com sucesso.", "success");
    } catch (error) {
      console.error("Erro ao desvincular arquivo", error);
      Swal.fire("Erro", "Não foi possível desvincular o arquivo.", "error");
    } finally {
      setRemovendoObjetoId(null);
    }
  };

  const iniciarReordenacao = () => {
    if (isSecaoFinalizada) return;
    if (!podeReordenar) return;
    setIsReordenando(true);
    setQuestoesOrdenadas(questoesOrdenadasPorOrdem);
  };

  const cancelarReordenacao = () => {
    setIsReordenando(false);
    setQuestoesOrdenadas([]);
  };

  const moverQuestao = (questaoSecaoId, direction) => {
    setQuestoesOrdenadas((prev) => {
      const index = prev.findIndex(
        (item) => item.IDQuestao_Secao === questaoSecaoId
      );
      if (index < 0) return prev;
      const destino = index + direction;
      if (destino < 0 || destino >= prev.length) return prev;
      const next = [...prev];
      const [item] = next.splice(index, 1);
      next.splice(destino, 0, item);
      return next;
    });
  };

  const salvarReordenacao = async () => {
    if (isSecaoFinalizada) return;
    if (!secaoId || !questoesOrdenadas.length) return;

    try {
      setSalvandoOrdem(true);
      Swal.fire({
        title: "Salvando ordem...",
        text: "Aguarde enquanto atualizamos as questões.",
        allowOutsideClick: false,
        allowEscapeKey: false,
        didOpen: () => Swal.showLoading(),
      });

      const atualizadas = questoesOrdenadas.map((questao, index) => ({
        ...questao,
        ordem: index + 1,
      }));

      await Promise.all(
        atualizadas.map((questao) =>
          api.put(`/chkquestaosecao/${questao.IDQuestao_Secao}`, {
            IDQuestao: questao.IDQuestao,
            IDSecao: secaoId,
            ordem: questao.ordem,
          })
        )
      );

      Swal.close();

      await Swal.fire({
        icon: "success",
        title: "Ordem salva!",
        text: "A nova ordem foi aplicada com sucesso.",
      });

      setIsReordenando(false);
      setQuestoesOrdenadas([]);
      fetchQuestoes();
    } catch (error) {
      console.error("Falha ao salvar ordem das questões", error);
      Swal.fire({
        icon: "error",
        title: "Erro",
        text: "Não foi possível salvar a nova ordem.",
      });
    } finally {
      setSalvandoOrdem(false);
    }
  };

  const desvincularQuestaoDaSecao = async (questaoSecaoID) => {
    if (isSecaoFinalizada) return;
    const { value: confirmacao } = await Swal.fire({
      title: "Confirmar desvínculo",
      html: `
    <p>Esta ação irá <strong>desvincular definitivamente</strong> a questão desta seção.</p>
    <p>Para confirmar, digite <strong>confirmar</strong> abaixo:</p>
  `,
      input: "text",
      inputPlaceholder: "Digite confirmar",
      customClass: {
        popup: 'swal-popup-fix',
        input: 'swal-input-fix',
      },
      showCancelButton: true,
      confirmButtonText: "Desvincular",
      cancelButtonText: "Cancelar",
      cancelButtonColor: "var(--color-btnCancelar-danger)",
      customClass: {
        cancelButton: "swal-cancel-danger",
      },
      confirmButtonColor: "#d33",

      inputValidator: (value) => {
        if (!value || value.toLowerCase() !== "confirmar") {
          return 'Você precisa digitar "confirmar" para prosseguir.';
        }
        return null;
      },
    });



    if (!confirmacao || confirmacao.toLowerCase() !== "confirmar") {
      return;
    }

    try {
      await api.delete(`/chkquestaosecao/${questaoSecaoID}`);

      await Swal.fire({
        icon: "success",
        title: "Desvinculado!",
        text: "A questão foi desvinculada da seção com sucesso.",
        timer: 2000,
        showConfirmButton: false,
      });

      // Atualiza dados da tela
      fetchSecao();
      fetchQuestoes();

    } catch (error) {
      console.error("Erro ao desvincular questão da seção", error);

      Swal.fire({
        icon: "error",
        title: "Erro",
        text: "Não foi possível desvincular a questão da seção.",
      });
    }
  };


  const totalPages = Math.ceil(total / limit);
  const listaExibida = isReordenando ? questoesOrdenadas : questoesOrdenadasPorOrdem;

  const handleReativarSecao = async () => {
    if (!isAdmin || !secaoId || !secao?.IDCliente || isReordenando) return;
    if (!isSecaoFinalizada) return;

    const confirmResult = await Swal.fire({
      title: "Reativar seção?",
      text: `Confirma reativar a seção "${secao.descricao}"?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sim, reativar",
      cancelButtonText: "Cancelar",
      cancelButtonColor: "var(--color-btnCancelar-danger)",
      customClass: {
        cancelButton: "swal-cancel-danger",
      },
    });

    if (!confirmResult.isConfirmed) return;

    try {
      setLoading(true);
      await api.put(`/chksecao/${secaoId}`, {
        IDSecao: secaoId,
        IDCliente: secao.IDCliente,
        descricao: secao.descricao,
        ordem: secao.ordem ?? null,
        situacao: 1,
      });
      await fetchSecao();
      await fetchQuestoes();
    } catch (error) {
      console.error("Erro ao reativar seção", error);
      Swal.fire("Erro", "Não foi possível reativar a seção.", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className={`menu-container-menu auditoria-questao-page ${hasSecaoParam ? "auditoria-questao-page--secao" : ""
        }`}
    >
      <MenuLateral />
      <div id="painel_principal_menu" align="center">
        <MenuSuperior userId={idFormatado} userName={nome} />

        <div className="mb-4">
          <h4 style={{ width: '100%', textAlign: 'center', paddingTop: '30px' }}>
            CADASTRO DE QUESTÕES - AUDITORIA
          </h4>

          {secao && !loading &&
            <div className="subtitle">
              <h5>{secao.descricao}</h5>
            </div>
          }
        </div>

        <div className="container mt-2 px-5">

          <div className="menuListArea">
            <div className="btn-voltarArea">
              <div className="actions">
                <button
                  type="button"
                  className="btn btn-secondary btn-sm btn-voltar"
                  onClick={handleVoltar}
                  disabled={!secao?.IDCliente}
                >
                  <IoReturnDownBackOutline size={18} style={{ marginRight: 6 }} />
                  Voltar
                </button>
              </div>
            </div>
            <div className="search-container">
              <span className="search-icon">
                <FiSearch />
              </span>
              <input
                type="text"
                className="search-input"
                placeholder="Buscar questão..."
                value={filter}
                onChange={onChangeFiltro}
                disabled={isReordenando || salvandoOrdem}
              />
              {filter.length > 0 && (
                <button
                  className="clear-btn"
                  onClick={clearFilter}
                  disabled={isReordenando || salvandoOrdem}
                >
                  <FiX />
                </button>
              )}
            </div>

            <div className="mainMenuList">
              <div className="actions">
                {Number(secaoId) > 0 && (
                  <button
                    className="btn-primary btnMainMenu"
                    onClick={abrirModalAssociarQuestao}
                    disabled={isReordenando || salvandoOrdem || isSecaoFinalizada}
                  >
                    <LuGitCompareArrows style={{ fontSize: 20 }} /> Associar questão
                  </button>
                )}
                <button
                  className="btn-primary btnMainMenu"
                  onClick={abrirModalNovaQuestao}
                  disabled={isReordenando || salvandoOrdem || isSecaoFinalizada}
                >
                  <MdPlaylistAdd style={{ fontSize: 20 }} /> Nova questão
                </button>
                {Number(secaoId) > 0 && !isReordenando && (
                  <button
                    className="btn-primary btnMainMenu"
                    onClick={iniciarReordenacao}
                    disabled={!podeReordenar || loading}
                  >
                    <FiMove style={{ fontSize: 20 }} /> Reordenar
                  </button>
                )}
                {Number(secaoId) > 0 && isReordenando && (
                  <>
                    <button
                      className="btn-primary btnMainMenu"
                      onClick={salvarReordenacao}
                      disabled={salvandoOrdem}
                    >
                      <FiCheck style={{ fontSize: 20 }} /> Salvar ordem
                    </button>
                    <button
                      className="btn-secondary btn-cancel-reorder btnMainMenu"
                      onClick={cancelarReordenacao}
                      disabled={salvandoOrdem}
                    >
                      <FiX style={{ fontSize: 20 }} /> Cancelar
                    </button>
                  </>
                )}
                {isSecaoFinalizada && isAdmin && (
                  <button
                    className="btn-secondary btnMainMenu btn-reativar-secao"
                    onClick={handleReativarSecao}
                    disabled={loading || isReordenando || salvandoOrdem}
                  >
                    Reativar seção
                  </button>
                )}
              </div>
              <div className="filter">
                <p style={{ margin: 0, paddingRight: 10, justifyContent: 'center' }}>Filtro:</p>
                <input
                  type="checkbox"
                  id="chkModelo"
                  checked={somenteModelo}
                  onChange={(e) => setSomenteModelo(e.target.checked)}
                  disabled={isReordenando || salvandoOrdem}
                  style={{ width: 12, height: 12, marginRight: 8 }}
                />
                <label htmlFor="chkModelo" style={{ margin: 0, fontSize: 12 }}>
                  Apenas questões modelo
                </label>
              </div>
            </div>
          </div>

          {loading && <p className="loading-text">Carregando...</p>}

          {!loading && !questoes.length && (
            <p className="empty-text">Nenhuma questão encontrada.</p>
          )}

          <ul className="questao-list">
            {listaExibida.map((questao, index) => (
              <div
                className={`questao-item ${isReordenando ? "reorder-item" : ""} ${!hasSecaoParam && !isReordenando ? "questao-item--clickable" : ""}`}
                key={questao.IDQuestao_Secao}
                onClick={() => {
                  if (!hasSecaoParam && !isReordenando && !isSecaoFinalizada) {
                    abrirModalEditarQuestao(questao);
                  }
                }}
              >
                {isReordenando && (
                  <div className="reorder-rail">
                    <button
                      className="reorder-btn"
                      onClick={(e) => {
                        e.stopPropagation();
                        moverQuestao(questao.IDQuestao_Secao, -1);
                      }}
                      disabled={index === 0 || salvandoOrdem}
                    >
                      <FiArrowUp />
                    </button>
                    <button
                      className="reorder-btn"
                      onClick={(e) => {
                        e.stopPropagation();
                        moverQuestao(questao.IDQuestao_Secao, 1);
                      }}
                      disabled={index === listaExibida.length - 1 || salvandoOrdem}
                    >
                      <FiArrowDown />
                    </button>
                  </div>
                )}
                <div
                  className={`questao-area ${isReordenando ? "reorder-mode" : ""}`}
                >
                  <div className="col-9 d-flex flex-column gap-2 justify-content-center">
                    <div className="row questao-left-row">
                      <div className="questao-left">
                        {secaoId && (
                          <div className="questao-ordem-box">
                            <span className="questao-ordem">{questao.ordem ?? "-"}</span>
                          </div>
                        )}
                        <strong className="questao-title">{questao.titulo}</strong>
                      </div>
                    </div>
                    <div className="row questao-left-row">
                      <div className="questao-left-description">
                        <strong className="questao-description">{questao.descricao}</strong>
                      </div>
                    </div>
                    <div className="row questao-left-row">
                      <div className="d-flex flex-row justify-content-between">
                        <div className="questao-details">
                          <p className="questao-label">Tipo:</p>
                          <p className="questao-value"> {Enum.ETipoQuestao[questao.tipo]}</p>
                          <p className="questao-label">Questão Modelo:</p>
                          <p className="questao-value">
                            {questao.questaoModelo === 1 ? (
                              <FaCheckCircle className="questao-icon-yes" />
                            ) : (
                              <FaTimesCircle className="questao-icon-no" />
                            )}
                          </p>
                          <p className="questao-label">Disponível para análise:</p>
                          <p className="questao-value">
                            {questao.habilitaAnalise === 1 ? (
                              <FaCheckCircle className="questao-icon-yes" />
                            ) : (
                              <FaTimesCircle className="questao-icon-no" />
                            )}
                          </p>
                        </div>
                      </div>
                    </div>
                    {secaoId && (
                      <div className="row questao-left-row">
                        <div className="questao-objeto">
                          <div className="questao-objeto-info">
                            <div className="questao-objeto-processo">
                              <div className="questao-icon-processo">
                                <FaArchive className="questao-icon" />
                              </div>
                              <div className="questao-label-objeto">
                                {questao.IDObjeto
                                  ? (objetosPorId[questao.IDObjeto]?.processo ||
                                    "Carregando arquivo...")
                                  : "Nenhum arquivo vinculado."}
                              </div>
                            </div>
                            {questao.IDObjeto && objetosPorId[questao.IDObjeto] && (
                              <div className="questao-objeto-arquivo">
                                <div className="questao-icon-file">
                                  <FaFileAlt className="questao-icon" />
                                </div>
                                <div className="questao-label-objeto questao-label-objeto--path">
                                  <span
                                    className="questao-path questao-path--clickable"
                                    onClick={() => {
                                      if (!isSecaoFinalizada) {
                                        abrirArquivoInline(objetosPorId[questao.IDObjeto]);
                                      }
                                    }}
                                    role="button"
                                    tabIndex={isSecaoFinalizada ? -1 : 0}
                                    onKeyDown={(event) => {
                                      if (isSecaoFinalizada) return;
                                      if (event.key === "Enter" || event.key === " ") {
                                        event.preventDefault();
                                        abrirArquivoInline(objetosPorId[questao.IDObjeto]);
                                      }
                                    }}
                                    title="Abrir arquivo"
                                  >
                                    {objetosPorId[questao.IDObjeto]?.tipo === 2
                                      ? objetosPorId[questao.IDObjeto]?.descricao
                                      : objetosPorId[questao.IDObjeto]?.path}
                                  </span>
                                </div>
                              </div>
                            )}
                          </div>
                          {questao.situacao !== 0 && questao.qntRespostas === 0 && (
                            <div className="questao-objeto-actions">
                              <button
                                type="button"
                                className="questao-objeto-btn"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  if (!isSecaoFinalizada) {
                                    abrirModalObjeto(questao);
                                  }
                                }}
                                disabled={isSecaoFinalizada}
                              >
                                <TfiClip />
                                {questao.IDObjeto || questao.qntObjetos > 0
                                  ? "Alterar arquivo"
                                  : "Add arquivo"}
                              </button>
                              {questao.IDObjeto && (
                                <button
                                  type="button"
                                  className="questao-objeto-btn questao-objeto-btn-delete"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    if (!isSecaoFinalizada) {
                                      excluirObjetoDaQuestao(questao);
                                    }
                                  }}
                                  disabled={removendoObjetoId === questao.IDQuestao_Secao || isSecaoFinalizada}
                                >
                                  <LuFileX2 />
                                  Excluir arquivo
                                </button>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="col-3 d-flex flex-column gap-2 justify-content-center">
                    <div className="row m-0">
                      <div className="questao-right">
                        <p className="questao-date-label">Atualizado em:</p>
                        <p className="questao-date-value">
                          {new Date(questao.dataAlteracao).toLocaleDateString('pt-BR')} -{' '}
                          {new Date(questao.dataAlteracao).toLocaleTimeString('pt-BR', {
                            hour: '2-digit',
                            minute: '2-digit',
                          })}
                        </p>
                      </div>
                    </div>
                    <div className="row m-0">
                      <div className="questao-right">
                        <p className="questao-label">Situação:</p>
                        {questao.situacao === 0 ?
                          <div className="d-flex justify-content-between align-items-center">
                            <FaTimesCircle style={{ color: 'red' }} />
                            <p className="questao-value" style={{ color: 'red', paddingLeft: 15 }}> Inativo</p>
                          </div>
                          :
                          <div className="d-flex justify-content-between align-items-center">
                            <FaCheckCircle style={{ color: '#3228e8ff' }} />
                            <p className="questao-value" style={{ color: '#3228e8ff', paddingLeft: 15 }}> Ativo </p>
                          </div>
                        }
                      </div>
                    </div>
                    {!secaoId && (
                      <div>
                        <div className="row m-0">
                          <div className="questao-right">
                            <p className="questao-date-label">Presente em:</p>
                            <p className="questao-date-value">{questao.qntSecoes} {questao.qntSecoes <= 1 ? 'seção' : 'seções'}</p>
                          </div>
                        </div>
                        <div className="row m-0">
                          <div className="questao-right">
                            <p className="questao-date-label">Respostas:</p>
                            <p className="questao-date-value">{questao.qntRespostas} {questao.qntRespostas <= 1 ? 'resposta' : 'respostas'}</p>
                          </div>
                        </div>
                      </div>
                    )}
                    {secaoId && questao.IDQuestao_Secao && (
                      <div className="row m-0">
                        <div className="questao-right">
                          {questao.qntRespostas > 0 || questao.qntObjetos > 0 ? (
                            <div className="questao-aviso-area">
                              <p className="questao-date-value">
                                Questão já possui resposta ou arquivo anexado nesta seção.
                              </p>
                            </div>
                          ) : (
                            <button
                              className="btn btn-danger desvincular-btn"
                              disabled={isReordenando || salvandoOrdem || isSecaoFinalizada}
                              onClick={(e) => {
                                e.stopPropagation();
                                if (!isReordenando && !isSecaoFinalizada) {
                                  desvincularQuestaoDaSecao(questao.IDQuestao_Secao);
                                }
                              }}>
                              <MdPlaylistRemove /> Desvincular da seção
                            </button>
                          )}
                        </div>
                      </div>
                    )}
                  </div>

                </div>
              </div>
            ))}
          </ul>

          {/* Paginação */}
          <div className="pagination">
            <button
              onClick={() => setPage((p) => Math.max(p - 1, 1))}
              disabled={page === 1 || isReordenando}
            >
              <FiChevronLeft size={18} style={{ marginRight: 4 }} />
            </button>

            <span>Página {page} de {totalPages}</span>

            <button
              onClick={() => setPage((p) => p + 1)}
              disabled={page >= totalPages || isReordenando}
            >
              <FiChevronRight size={18} style={{ marginLeft: 4 }} />
            </button>
          </div>
        </div>

      </div >
      {showModalQuestao && (
        <CadastroQuestaoModal
          open={showModalQuestao}
          questao={questaoEditando}
          secaoID={secaoId}
          onClose={() => setShowModalQuestao(false)}
          onSaved={fetchQuestoes}
        />
      )}

      {showModalAssociarQuestao && (
        <AssociacaoQuestaoModal
          secaoId={secaoId}
          onClose={() => setShowModalAssociarQuestao(false)}
          onAssociarSuccess={() => fetchQuestoes()} // recarrega lista após vínculo
        />
      )}

      {showModalObjeto && (
        <ModalSelecionarObjeto
          open={showModalObjeto}
          IDCliente={secao?.IDCliente}
          onClose={() => {
            setShowModalObjeto(false);
            setQuestaoSelecionadaObjeto(null);
          }}
          onConfirm={vincularObjeto}
        />
      )}
    </div >
  );
};

export default AuditoriaQuestao;

